import { render, staticRenderFns } from "./ImprimirLabel.vue?vue&type=template&id=278849c9&"
import script from "./ImprimirLabel.vue?vue&type=script&lang=js&"
export * from "./ImprimirLabel.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports